import { render, staticRenderFns } from "./IndustrySolution.vue?vue&type=template&id=a84bd77c&scoped=true&"
import script from "./IndustrySolution.vue?vue&type=script&lang=js&"
export * from "./IndustrySolution.vue?vue&type=script&lang=js&"
import style0 from "./IndustrySolution.vue?vue&type=style&index=0&id=a84bd77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84bd77c",
  null
  
)

export default component.exports